// Single source of truth for the unified onboarding stepper. "Create account"
// is node 0, so every intake screen sits one node later.

export const STEP_KEYS_SELF = [
  "createAccount",
  "yourSymptoms",
  "bookAppointment",
  "insurance",
  "emergencyContact",
] as const;

export const STEP_KEYS_SUPPORTED = [
  "createAccount",
  "yourSymptoms",
  "emergencyContact",
] as const;

export type StepKey = (typeof STEP_KEYS_SELF)[number];

// Anything other than "supported" (including undefined while attributes load)
// falls back to the full self journey.
export const getStepKeys = (registrationType?: string): readonly StepKey[] =>
  registrationType === "supported" ? STEP_KEYS_SUPPORTED : STEP_KEYS_SELF;

export const ONBOARDING_STEP_INDEX = Object.fromEntries(
  STEP_KEYS_SELF.map((key, index) => [key, index])
) as Record<StepKey, number>;
